import { render, staticRenderFns } from "./PageReel.vue?vue&type=template&id=dc0e86c0&scoped=true"
import script from "./PageReel.vue?vue&type=script&lang=js"
export * from "./PageReel.vue?vue&type=script&lang=js"
import style0 from "./PageReel.vue?vue&type=style&index=0&id=dc0e86c0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc0e86c0",
  null
  
)

export default component.exports